import type { Toaster } from '#composables/notifications/types/notification.type';
import { inject } from 'vue';

export const useNotification = () => {
  const addNotification = inject<(props: Toaster) => void>('addToaster');

  const notify = ({
    title,
    body,
    status,
    autoclose
  }: {
    title: string;
    body: string;
    status?: Toaster['status'];
    autoclose?: boolean;
  }) => {
    if (addNotification) {
      addNotification({ title, body, status: status ?? 'info', autoclose: autoclose ?? true });
    }
  };

  return { notify };
};
